@if (password()) {
  <div class="pwd-strength-wrap">
    <div class="pwd-bar pwd-bar--{{ meta().cls }}">
      <div class="pwd-bar-seg" [class.filled]="score() >= 1"></div>
      <div class="pwd-bar-seg" [class.filled]="score() >= 2"></div>
      <div class="pwd-bar-seg" [class.filled]="score() >= 3"></div>
      <div class="pwd-bar-seg" [class.filled]="score() >= 4"></div>
      <div class="pwd-bar-seg" [class.filled]="score() >= 5"></div>
    </div>
    <span class="pwd-level pwd-level--{{ meta().cls }}">{{ meta().label }}</span>
  </div>

  <div class="pwd-rules">
    <div class="pwd-rule" [class.pwd-rule--met]="rules().minLength">
      <span class="mdi" [class.mdi-check-circle]="rules().minLength" [class.mdi-circle-outline]="!rules().minLength"></span>
      8+ characters
    </div>
    <div class="pwd-rule" [class.pwd-rule--met]="rules().hasUpper">
      <span class="mdi" [class.mdi-check-circle]="rules().hasUpper" [class.mdi-circle-outline]="!rules().hasUpper"></span>
      Uppercase (A–Z)
    </div>
    <div class="pwd-rule" [class.pwd-rule--met]="rules().hasLower">
      <span class="mdi" [class.mdi-check-circle]="rules().hasLower" [class.mdi-circle-outline]="!rules().hasLower"></span>
      Lowercase (a–z)
    </div>
    <div class="pwd-rule" [class.pwd-rule--met]="rules().hasNumber">
      <span class="mdi" [class.mdi-check-circle]="rules().hasNumber" [class.mdi-circle-outline]="!rules().hasNumber"></span>
      Number (0–9)
    </div>
    <div class="pwd-rule" [class.pwd-rule--met]="rules().hasSpecial">
      <span class="mdi" [class.mdi-check-circle]="rules().hasSpecial" [class.mdi-circle-outline]="!rules().hasSpecial"></span>
      Special character
    </div>
  </div>
}
